module.exports = __webpack_public_path__ + "static/media/cal-3.6292853c.jpg";